import { Skeleton } from '@mui/material'
import { useGetByTenantRiskmanagementLatestHoldingstransferbalancesreconciliationQuery } from 'api/rtk-api'

import { TENANT } from '@/const'
import { plural } from '@/utilities/plural'

import classes from './reconciliation-result.module.scss'

export const ReconciliationResult = () => {
  const { data, isLoading } =
    useGetByTenantRiskmanagementLatestHoldingstransferbalancesreconciliationQuery({
      tenant: TENANT
    })

  if (isLoading) return <Skeleton height="20px" variant="rectangular" width="140px" />

  const total = data?.entries?.length ?? 0
  return (
    <strong className={classes.assetResults}>
      {total} {plural('asset', total)}
    </strong>
  )
}
